"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var Wrapper = exports.Wrapper = _styledComponents["default"].section(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .rc-time-picker {\n    width: 100%;\n\n    input {\n      width: 100%;\n      height: calc(1em + 1.375rem + 2px);\n      font-size: 16px;\n      color: #333;\n      background-color: #fff;\n      background-clip: padding-box;\n      border: 1px solid #e8e8e8;\n      padding: 0.6875rem 0.6875rem;\n    }\n\n    .rc-time-picker-clear-icon:after {\n      display: none;\n    }\n  }\n"])));